"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachReactComponent = void 0;
var react_1 = __importDefault(require("react"));
var PdfPreviewComponent_1 = __importDefault(require("../PdfPreviewComponent/PdfPreviewComponent"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var attachReactComponent = function (mountReactComponent, publicLink, pdfUrl, defaultPreviewSettings, getOneTimeToken, trackPdfPreviewAction, updateDefaultPreviewSettings, usingFeature, closePreview) {
    return mountReactComponent(react_1.default.createElement(PdfPreviewComponent_1.default, { disableLayout: usingFeature(FeatureFlag_1.default.OptOutNewEditor), publicLink: publicLink, pdfUrl: pdfUrl, defaultPreviewSettings: defaultPreviewSettings, getOneTimeToken: getOneTimeToken, trackPdfPreviewAction: trackPdfPreviewAction, updateDefaultPreviewSettings: updateDefaultPreviewSettings, closePreview: closePreview }));
};
exports.attachReactComponent = attachReactComponent;
